import React from 'react'

import ContentPageLayout from '../../../ContentPageLayout/ContentPageLayout'
import mixpanel from '../../../../../utilities/mixpanel'
import { sendCrispMessage } from '../../../../../utilities/crisp'

function HandlingLTSRegistrations() {
  return (
    <ContentPageLayout
      category="Learn To Skate Class Management"
      title="LTS USA Memberships: What Parents Need to Do"
      intro="Parents are responsible for registering, renewing, and paying for their student's membership directly with Learn to Skate USA. For classes that require an LTS membership number, Leevo collects that number during class registration. Leevo does not register students with LTS USA, manage renewals, or verify membership status."
      description="Parents manage Learn to Skate USA memberships and renewals directly with LTS USA. Learn when to enter an LTS membership number for classes in Leevo."
      path="/support/handling_lts_registrations"
      datePublished="2026-01-01"
    >
      <section>
        <h2>Before Registering for Classes</h2>
        <p>If your program requires an LTS USA membership, follow these steps:</p>
        <ol>
          <li>
            <strong>Register or renew directly with LTS USA.</strong> Visit{' '}
            <a href="https://www.learntoskateusa.com/registration/" target="_blank" rel="noopener noreferrer">
              Learn to Skate USA
            </a>{' '}
            to set up or renew your student&apos;s membership and pay any membership fees directly to LTS USA.
          </li>
          <li>
            <strong>Have your student&apos;s membership number ready.</strong> Find it in your LTS USA account or
            membership confirmation email. Check with LTS USA that the membership is current.
          </li>
          <li>
            <strong>Enter the number in Leevo.</strong> Return to your program&apos;s class registration and enter your
            student&apos;s LTS membership number when prompted. Class registration and payments are separate from your
            LTS USA membership.
          </li>
        </ol>
      </section>
      <section>
        <h2>Keeping Memberships Current</h2>
        <p>
          Parents are responsible for checking membership expiration dates and completing renewals directly with LTS
          USA. Having a membership number saved in Leevo does not confirm that the membership is active.
        </p>
        <p>
          Leevo does not check membership status or expiration dates, send LTS renewal reminders, or complete renewals.
          For help with membership registration, payments, or renewals, contact Learn to Skate USA directly.
        </p>
      </section>
      <section>
        <h2>What This Means for Program Directors</h2>
        <p>
          Leevo supports LTS curriculum and skill tracking and stores the membership numbers parents provide. Make sure
          families know they need to manage their memberships and renewals directly with LTS USA.
        </p>
        <p>
          Collecting a membership number in Leevo does not verify membership status or insurance coverage. Follow your
          program&apos;s process for confirming that students meet its participation requirements.
        </p>
      </section>
      <section>
        <h2>Questions About Using Leevo?</h2>
        <p>
          Need help entering a membership number or registering for classes in Leevo?{' '}
          <a
            href="#"
            onClick={() => {
              sendCrispMessage('I need help entering an LTS membership number or registering for classes in Leevo.')
              mixpanel.track('Clicked Support Chat')
            }}
          >
            Start a chat with us
          </a>
          .
        </p>
      </section>
    </ContentPageLayout>
  )
}

HandlingLTSRegistrations.propTypes = {}

export default HandlingLTSRegistrations
